import React, { useState } from "react";
import { FaPlay } from "react-icons/fa";
import FsLightbox from "fslightbox-react";
import SectionTitle from "../../elements/section-title/SectionTitle";

const VideoTwo = () => {
  const [toggler, setToggler] = useState(false);

  return (
    <>
      <div
        id="presentation-video"
        className="section section-padding-equal"
        style={{ padding: "60px 0px 60px 0" }}
      >
        <div className="container">
          <SectionTitle
            subtitle="Découvrez la sous‑location professionnelle"
            title="Vos loyers sécurisés, votre bien valorisé"
            description="Avec LocaJoy, vous confiez votre logement à une équipe de professionnels : bail sécurisé, sélection de locataires triés sur le volet et gestion intégrale. Vous percevez un loyer garanti chaque mois, sans effort ni impayés."
            textAlignment=""
            textColor=""
          />
          <div className="about-expert">
            <div className="thumbnail">
              <img
                src={process.env.PUBLIC_URL + "/images/banner/111.jpg"}
                alt="Présentation"
              />
              <div className="popup-video">
                <button
                  className="play-btn"
                  onClick={() => setToggler(!toggler)}
                >
                  <FaPlay />
                </button>
              </div>
            </div>
          </div>
        </div>
        <ul className="shape-group-16 list-unstyled">
          <li className="shape shape-1">
            <img
              src={process.env.PUBLIC_URL + "/images/others/circle-2.png"}
              alt="circle"
            />
          </li>
          <li className="shape shape-2">
            <img
              src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
              alt="Line"
            />
          </li>
          <li className="shape shape-3">
            <img
              src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
              alt="Line"
            />
          </li>
        </ul>
      </div>
      {/* Vidéo de présentation dans une lightbox */}
      <FsLightbox
        toggler={toggler}
        sources={[
          <video
            className="fslightbox-source fslightbox-video fslightbox-opacity-1"
            autoPlay
            style={{ width: "706px", height: "397.125px" }}
            controls
          >
            <source
              src={process.env.PUBLIC_URL + "/images/thermostat.mp4"}
              type="video/mp4"
            />
          </video>,
        ]}
      />
    </>
  );
};

export default VideoTwo;
